/** The name of the HTTP onCall function to get the story markdown content */
export const HTTP_ARTICLE_CONTENT_HELP = "getArticleContent"

/** The name of the HTTP onCall function to get the story markdown content */
export const HTTP_STORY_CONTENT_NEWS = "getStoryContent"